import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { OVERRIDE_CONFIRM_LABEL, OVERRIDE_DIALOG_DESCRIPTION, OVERRIDE_DIALOG_TITLE } from './constants';
import {
  ConfirmButton,
  DialogActionsStyled,
  DialogCancelButton,
  DialogDescription,
  DialogTitleStyled,
  FieldLabel,
  FieldWrapper,
  ReasonField,
  RequiredMark,
} from './styled';
import { OverrideValidationDialogProps } from './types';

const OverrideValidationDialog = ({ open, onClose, onSubmit }: OverrideValidationDialogProps) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setReason('');
    setSubmitting(false);
  }, [open]);

  const canSubmit = Boolean(reason.trim()) && !submitting;

  const handleSubmit = async () => {
    if (!canSubmit) return;

    try {
      setSubmitting(true);
      await onSubmit(reason.trim());
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitleStyled>
        {OVERRIDE_DIALOG_TITLE}
        <IconButton aria-label="close" onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitleStyled>

      <DialogContent>
        <DialogDescription>{OVERRIDE_DIALOG_DESCRIPTION}</DialogDescription>
        <FieldWrapper>
          <FieldLabel>
            Reason
            <RequiredMark>*</RequiredMark>
          </FieldLabel>
          <ReasonField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            placeholder="Why this report can be attached"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            inputProps={{ 'aria-label': 'Reason' }}
          />
        </FieldWrapper>
      </DialogContent>

      <DialogActionsStyled>
        <DialogCancelButton onClick={onClose} disabled={submitting}>
          Cancel
        </DialogCancelButton>
        <ConfirmButton variant="contained" onClick={handleSubmit} disabled={!canSubmit}>
          {OVERRIDE_CONFIRM_LABEL}
        </ConfirmButton>
      </DialogActionsStyled>
    </Dialog>
  );
};

export default OverrideValidationDialog;
